import { useTheme } from '@mui/material';
import DSBox from '../../../../../design-system/DSBox';
import DSGrid from '../../../../../design-system/DSGrid';
import KlydoCard from '../../../../Klydos/KlydosList/components/KlydoCard';
import {
  CollectionType,
  CollectionUnion,
} from '../../../../../api/collections';
import { PopulatedKlydo } from '../../../../../api/klydo';

export type ContentTabProps = {
  collection: CollectionUnion;
  onKlydoClick: (klydo: PopulatedKlydo) => void;
};

const ContentTab = ({ collection, onKlydoClick }: ContentTabProps) => {
  const { spacing } = useTheme();

  return (
    <DSBox>
      <DSGrid
        container
        spacing={{
          xs: spacing(3),
          sm: spacing(5),
          md: spacing(6),
        }}
        columns={{ xs: 1 }}
      >
        {collection?.klydos?.map((klydo) => {
          return (
            <KlydoCard
              key={klydo.id}
              klydo={klydo}
              isStatic
              isMenuHidden
              pendulumLogo={collection.logoUrl}
              pendulumLogoSize={
                collection.type === CollectionType.Draft
                  ? (collection.pendulumLogoSize ?? undefined)
                  : undefined
              }
              isApprovedCollection={collection.type === CollectionType.Approved}
              pendulumLogoType={collection.pendulumLogoType}
              onSelect={onKlydoClick}
            />
          );
        })}
      </DSGrid>
    </DSBox>
  );
};

export default ContentTab;
